import LargeBlueButton from '@components/common/button/LargeBlueButton';
import EnumField from '@components/common/form/formik/input/EnumField';
import LabeledField from '@components/common/form/formik/input/LabeledField';
import { ApprovalStatus } from '@data/course/approval/approval';
import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

interface CourseApprovalMenuProps {
  onSubmit: (status: ApprovalStatus, comments: string) => Promise<void>;
}

// For use with EnumField
enum InternalStatus {
  Approve = 'Approve',
  Flag = 'Approve With Flag',
  Deny = 'Deny',
}

const CourseApprovalMenu: React.FC<CourseApprovalMenuProps> = ({ onSubmit }) => {
  const validationSchema = Yup.object({
    status: Yup.string().required().oneOf(Object.values(InternalStatus)),
    comments: Yup.string().max(200, 'Comments cannot be longer than 200 characters'),
  });

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={{ status: InternalStatus.Approve, comments: '' }}
      onSubmit={({ status, comments }) => {
        switch (status) {
          case InternalStatus.Approve:
            onSubmit(ApprovalStatus.Approved, comments);
            break;
          case InternalStatus.Flag:
            onSubmit(ApprovalStatus.Flag, comments);
            break;
          case InternalStatus.Deny:
            onSubmit(ApprovalStatus.Denied, comments);
            break;
        }
      }}
    >
      <Form className='flex flex-col gap-6'>
        <EnumField name='status' label='Approval Status' enumToUse={InternalStatus}></EnumField>
        <LabeledField
          name='comments'
          label='Comments'
          as='textarea'
          className='align-middle w-full xl:w-2/3'
        />
        <LargeBlueButton
          text='SUBMIT'
          type='submit'
          className='lg:w-64 self-center'
        ></LargeBlueButton>
      </Form>
    </Formik>
  );
};

export default CourseApprovalMenu;
